module.exports = __webpack_public_path__ + "static/media/Hospitality_16.e78deb9d.jpg";